var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    { staticClass: "navbar navbar-default navbar-fixed-bottom mobile" },
    [
      _c("div", { staticClass: "alignBox" }, [
        _c(
          "div",
          {
            staticClass: "container",
            style: {
              "justify-content": _vm.GetrestoService.fromGetresto
                ? "space-around !important"
                : "normal",
            },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "footerBlock d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.GetrestoService.fromGetresto && !_vm.isInAdmin(),
                        expression:
                          "!GetrestoService.fromGetresto && !isInAdmin()",
                      },
                    ],
                    staticClass: "bottomIconBlock bottomMenuCms",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "cmsToggle",
                        attrs: {
                          "data-target": "#modalNavigation",
                          "data-toggle": "modal",
                          href: "",
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon-eatselfapp_menu-burger" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("Menu")]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "bottomIconBlock btn-group notification" },
                  [
                    !_vm.user && _vm.isInAdmin()
                      ? _c(
                          "a",
                          {
                            staticClass: "connexion",
                            staticStyle: { display: "block" },
                            attrs: { href: "/admin" },
                          },
                          [
                            _c("i", { staticClass: "icon-eatselfapp_lock" }),
                            _c("p", [_vm._v("Connexion")]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.client && !_vm.isInAdmin()
                      ? _c(
                          "a",
                          {
                            staticClass: "connexion",
                            staticStyle: { display: "block" },
                            attrs: { href: "" },
                            on: {
                              click: [
                                function ($event) {
                                  $event.preventDefault()
                                },
                                function ($event) {
                                  $event.preventDefault()
                                  return _vm.UiService.showClientLoginModal()
                                },
                              ],
                            },
                          },
                          [
                            _c("i", { staticClass: "icon-eatselfapp_lock" }),
                            _c("p", [_vm._v("Connexion")]),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.client && !_vm.isInAdmin()
                      ? _c("div", { staticClass: "btn-group userMenu" }, [
                          _c(
                            "a",
                            {
                              staticClass: "xdropdown-toggle user",
                              attrs: {
                                href: "",
                                "data-target": "#modalUserNav",
                                "data-toggle": "modal",
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                },
                              },
                            },
                            [
                              _c("span", { staticClass: "boxIcon" }, [
                                _c("span", { staticClass: "first" }, [
                                  _vm._v(
                                    _vm._s((_vm.client.FirstName || "")[0])
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "last" }, [
                                  _vm._v(
                                    _vm._s((_vm.client.LastName || "")[0])
                                  ),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c("p", [_vm._v("Compte")]),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.shop
                            ? _c(
                                "ul",
                                {
                                  staticClass:
                                    "hidden dropdown-menu MobileMenuAdmin",
                                },
                                [
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId + "/client/details",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "clyo clyo-gear",
                                        }),
                                        _c("span", [_vm._v("Mon Compte")]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href:
                                            _vm.shop.ShopId + "/client/orders",
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "clyo clyo-cart",
                                        }),
                                        _c("span", [_vm._v("Mes Commandes")]),
                                      ]
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _vm.client.comoMembership ||
                                  _vm.ClientService.clientFidCardForShop(
                                    _vm.client,
                                    _vm.shop
                                  )
                                    ? _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                _vm.shop.ShopId +
                                                "/client/details#fidelite",
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "icone-star",
                                            }),
                                            _c("span", [_vm._v("Ma fidélité")]),
                                          ]
                                        ),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("li", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "" },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.ClientService.logout()
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "clyo clyo-disconect",
                                        }),
                                        _c("span", [_vm._v("Déconnexion")]),
                                      ]
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isInAdmin() && _vm.user
                      ? _c(
                          "div",
                          {
                            staticClass: "btn-group userMenu dropup",
                            staticStyle: {
                              display: "block",
                              position: "static",
                            },
                          },
                          [
                            _c(
                              "a",
                              {
                                staticClass: "dropdown-toggle user",
                                staticStyle: { margin: "0" },
                                attrs: { "data-toggle": "dropdown", href: "" },
                              },
                              [
                                _c("div", { staticClass: "boxIcon" }, [
                                  _c("span", { staticClass: "first" }, [
                                    _vm._v(
                                      _vm._s(_vm.user.UserName.split(" ")[0][0])
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", { staticClass: "last" }, [
                                    _vm._v(
                                      _vm._s(_vm.user.UserName.split(" ")[1][0])
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "p",
                                    {
                                      staticStyle: { "white-space": "nowrap" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.shop.DefaultName) + " "
                                      ),
                                      _c("span", { staticClass: "caret" }),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "ul",
                              { staticClass: "dropdown-menu MobileMenuUser" },
                              [
                                _vm._m(0),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.UiService.editOptionGroups()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icone icone-lab",
                                      }),
                                      _c("span", [_vm._v("Groupes d'options")]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _vm._m(1),
                                _vm._v(" "),
                                _vm._m(2),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: _vm.user.ShopId + "/carte/0",
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "icone icone-shop",
                                      }),
                                      _c("span", [_vm._v("Passer commande")]),
                                    ]
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "" },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.UserService.logout()
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "clyo clyo-disconect",
                                      }),
                                      _c("span", [_vm._v("Déconnecter")]),
                                    ]
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                !_vm.isInAdmin() &&
                _vm.shop &&
                !_vm.shop.info.display.hideOrderButtons
                  ? _c(
                      "div",
                      {
                        staticClass: "bottomIconBlock navbar-header carteMenu",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "leftMenu",
                            attrs: { href: "", id: "menu-toggle-mobile" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.UiService.toggleSidebar()
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-eatselfapp_menu-card",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "icon-eatselfapp_menu-card-bg backIcon",
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.shop && _vm.shop.productTree.product.dn
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInAdmin()
                  ? _c(
                      "div",
                      {
                        staticClass: "bottomIconBlock navbar-header carteMenu",
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "leftMenu",
                            attrs: { href: "", id: "menu-toggle-mobile" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.UrlService.includes("admin2.carte")
                                  ? _vm.UiService.toggleSidebar()
                                  : _vm.UrlService.go({
                                      name: "admin2.carte.current",
                                      params: { tid: 0 },
                                    })
                              },
                            },
                          },
                          [
                            _c("i", {
                              staticClass: "icon-eatselfapp_menu-card",
                            }),
                            _vm._v(" "),
                            _c("i", {
                              staticClass:
                                "icon-eatselfapp_menu-card-bg backIcon",
                            }),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                _vm._s(
                                  _vm.shop && _vm.shop.productTree.product.dn
                                )
                              ),
                            ]),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value:
                          !_vm.isInAdmin() && _vm.shop && _vm.shop.canOrder,
                        expression: "!isInAdmin() && shop && shop.canOrder",
                      },
                    ],
                    staticClass: "bottomIconBlock btn-group cart",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass: "btn dropdown-toggle",
                        staticStyle: { position: "relative" },
                        attrs: { href: "" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.UiService.toggleCart()
                          },
                        },
                      },
                      [
                        _c("i", { staticClass: "icon-eatselfapp_cart" }),
                        _vm._v(" "),
                        _vm.CartService.nbArticles() !== 0
                          ? _c("span", { staticClass: "badge" }, [
                              _vm._v(_vm._s(_vm.CartService.nbArticles())),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("p", [_vm._v("Panier")]),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.shop &&
                !_vm.GetrestoService.fromGetresto &&
                !_vm.isInAdmin()
                  ? _c("div", { staticClass: "bottomIconBlock bottomPhone" }, [
                      _c(
                        "a",
                        {
                          staticClass: "topPhone",
                          attrs: { href: "tel:" + _vm.shop.Tel },
                        },
                        [
                          _c("i", {
                            staticClass: "icon-eatselfapp_phone-dots",
                          }),
                          _c("p", [_vm._v("Appel")]),
                        ]
                      ),
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.isInAdmin()
                  ? _c("div", { staticClass: "bottomIconBlock bottomPhone" }, [
                      _c(
                        "a",
                        {
                          staticClass: "carteMenu",
                          attrs: { id: "menu-toggle" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.UrlService.includes("admin2.profile")
                                ? _vm.UiService.toggleSidebar()
                                : _vm.UrlService.go("admin2.profile")
                            },
                          },
                        },
                        [
                          _c("i", { staticClass: "fa fa-sliders" }),
                          _c("p", { staticStyle: { "margin-top": "0px" } }, [
                            _vm._v("Paramètres"),
                          ]),
                        ]
                      ),
                    ])
                  : _vm._e(),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/profile" } }, [
        _c("i", { staticClass: "clyo clyo-gear" }),
        _c("span", [_vm._v("Paramètres")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/orders" } }, [
        _c("i", { staticClass: "icone icone-new-commande" }),
        _c("span", [_vm._v("Historique des commandes")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("li", [
      _c("a", { attrs: { href: "admin/carte/0" } }, [
        _c("i", { staticClass: "icone icone-editer" }),
        _c("span", [_vm._v("Editer la carte")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }